import { Box, IconButton } from '@mui/material';
import { forwardRef } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { ReactComponent as CloseIcon } from '../../assets/images/selectCloseIcon.svg';

interface DropdownIconComponentProps {
  disableClearable?: boolean;
  value?: string;
  disabled?: boolean;
  open: boolean;
  handleChange?: (value: string) => void;
  setOpen: (open: boolean) => void;
}

const DropdownIconComponent = forwardRef<
  HTMLDivElement,
  DropdownIconComponentProps
>(({ disableClearable, value, disabled, open, handleChange, setOpen }, ref) => {
  return (
    <Box
      ref={ref}
      sx={{
        position: 'absolute',
        right: 0,
        top: 0,
        bottom: 0,
        display: 'flex',
        alignItems: 'center',
        paddingRight: 1,
        gap: 0.5,
        pointerEvents: 'none',
        '& > *': {
          pointerEvents: 'auto',
        },
      }}
    >
      {!disableClearable && value && !disabled && (
        <IconButton
          onClick={(event) => {
            event.stopPropagation();
            if (handleChange && !disabled) {
              handleChange('');
            }
          }}
        >
          <CloseIcon
            style={{
              cursor: disabled ? 'not-allowed' : 'pointer',
            }}
          />
        </IconButton>
      )}
      <IconButton
        style={{
          padding: 2,
          cursor: disabled ? 'not-allowed' : 'pointer',
          pointerEvents: disabled ? 'none' : 'auto',
        }}
        onClick={(event) => {
          event.stopPropagation();
          if (!disabled) setOpen(true);
        }}
      >
        <KeyboardArrowDownIcon
          style={{
            cursor: disabled ? 'not-allowed' : 'pointer',
            transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.3s ease',
            color: '#97A6A5',
          }}
        />
      </IconButton>
    </Box>
  );
});

export default DropdownIconComponent;
